var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGrid1X2(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.439,
    height: 22.439,
    viewBox: "0 0 22.439 22.439",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "grid-1x2_1_",
    "data-name": "grid-1x2 (1)",
    d: "M8.04,1.34H1.34V20.1h6.7Zm12.06,0H13.4v6.7h6.7Zm0,12.06v6.7H13.4V13.4ZM0,1.34A1.34,1.34,0,0,1,1.34,0h6.7A1.34,1.34,0,0,1,9.38,1.34V20.1a1.34,1.34,0,0,1-1.34,1.34H1.34A1.34,1.34,0,0,1,0,20.1Zm12.06,0A1.34,1.34,0,0,1,13.4,0h6.7a1.34,1.34,0,0,1,1.34,1.34v6.7A1.34,1.34,0,0,1,20.1,9.38H13.4a1.34,1.34,0,0,1-1.34-1.34ZM13.4,12.06a1.34,1.34,0,0,0-1.34,1.34v6.7a1.34,1.34,0,0,0,1.34,1.34h6.7a1.34,1.34,0,0,0,1.34-1.34V13.4a1.34,1.34,0,0,0-1.34-1.34Z",
    transform: "translate(0.5 0.5)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrid1X2);
export default __webpack_public_path__ + "static/media/grid-1x2.8109f7fab96cc604b3575ded8b662ed2.svg";
export { ForwardRef as ReactComponent };